import React from 'react'

export function random_rgba() {
    let o = Math.round, r = Math.random, s = 255;
    return 'rgba(' + o(r() * s) + ',' + o(r() * s) + ',' + o(r() * s) + ',' + .6+ ')';
}
export const backgroundColors = [ "rgba(255, 215, 0, 1)","rgba(0, 128, 128, 1)","rgba(255, 0, 0, 1)","rgba(100, 216, 255, 1)","rgba(255, 179, 72, 1)","rgba(255, 87, 51, 1)","rgba(142, 68, 173,1)"] 

